import { get } from "lodash";
import { useMemo } from "react";
import { type PostProps } from "../../utils/post-props";

function IFrame({ asset }: PostProps) {
  const iFrameUrl = useMemo(
    () => get(asset, "customData.iframeTile.iFrameUrl"),
    [asset],
  );

  return <iframe src={iFrameUrl} width="100%" height="100%" />;
}

export function PostIframe({ asset, position, screen, post }: PostProps) {
  const interactive = useMemo<boolean>(
    () => !!get(asset, "customData.tile.interactive"),
    [asset],
  );

  if (interactive) {
    return (
      <IFrame asset={asset} position={position} screen={screen} post={post} />
    );
  }

  return (
    <div className="relative h-full w-full">
      <IFrame asset={asset} position={position} screen={screen} post={post} />
      <div className="absolute top-0 left-0 w-full h-full" />
    </div>
  );
}
